import { render, staticRenderFns } from "./domainCustomAddAssign.vue?vue&type=template&id=4e28d7ac&lang=pug"
import script from "./domainCustomAddAssign.vue?vue&type=script&lang=js"
export * from "./domainCustomAddAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports